import { Component } from '@angular/core';

@Component({
  selector: 'fgb-home-layout',
  templateUrl: './home-layout.component.html',
})
export class HomeLayoutComponent {}
